@if (dataSource()) {
  @if ((breakpoints$ | async).isDesktop) {
    <div class="header" puSort [formControl]="form.controls.sort">
      @if (dataSource().items?.length !== 0) {
        @for (column of columns(); track column) {
          @if (column.sortable) {
            <div class="column" [class.justify-end]="column.justifyContentEnd">
              <pu-sort [colName]="column.name">
                {{ column.i18nKey | translate }}
              </pu-sort>
            </div>
          } @else {
            <div
              class="column"
              [class.justify-end]="column.justifyContentEnd"
              [translate]="column.i18nKey"></div>
          }
        }
      }
    </div>
  }

  <div class="body" #tableBody (scroll)="tableScroll.emit()">
    @for (row of dataSource().items; track $index) {
      @if ((breakpoints$ | async).isDesktop) {
        <ng-container
          *ngTemplateOutlet="
            templateRef();
            context: { $implicit: row }
          "></ng-container>
      } @else {
        <ng-container
          *ngTemplateOutlet="
            templateMobile();
            context: { $implicit: row }
          "></ng-container>
      }
    } @empty {
      <div class="pp-bold-12" translate="table.placeholder.notFound"></div>
    }
  </div>
  @if (dataSource().itemsCount > 0 && withPagination()) {
    <pp-pagination
      class="paginator"
      data-testid="paginator"
      [pageSizeOptions]="pageSizeOptions()"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      [length]="dataSource().itemsCount" />
  }
} @else {
  <div class="header">
    <div class="pp-shimmer pp-caption"></div>
  </div>
  <div class="body">
    @for (column of columns(); track column) {
      <div class="pp-shimmer"></div>
    }
  </div>
}
